module.exports = __webpack_public_path__ + "img/avatar1.6788433e.png";